export interface IAwsSettings {
  id: string;
  name: string;
  accessKeyId: string;
  secretAccessKey: string;
  defaultFromEmail: string;
  selectedRegion: EAWSRegion;
  configIds?: string[];
}

export enum EAWSRegion {
  USWest2 = 0,
  EUWest3 = 1
}
